import React, { useEffect } from "react";
import ServiceTemplate from "../components/ServiceTemplate";

import mBanner from "../images/digital-1.png";
import mBig from "../images/digital-2.png";
import mCollage from "../images/digital-3.png";

import {
  FaSearch,
  FaBullseye,
  FaUsers,
  FaChartBar,
  FaStar
} from "react-icons/fa";

export default function Marketing() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

const sidebar = [
  {
    title: "Google & Meta Ads for Admissions",
    icon: FaBullseye,
  },
  {
    title: "SEO, Local Listings & Reputation Management",
    icon: FaSearch,
  },
  {
    title: "Higher Visibility Among Parents",
    icon: FaUsers,
  },
  {
    title: "Better-Quality Enquiries & Admissions",
    icon: FaStar,
  },
  {
    title: "Clear Reporting: Leads, Performance & ROI",
    icon: FaChartBar,
  },
];

  const features = [
    "SEO & technical optimization",
    "Performance marketing & ads",
    "Social strategy & content",
    "Analytics-driven growth",
    "Conversion rate optimization",
  ];

  return (
    <ServiceTemplate
      title="Digital Marketing"
      bannerImage={mBanner}
      bigImage={mBig}
      collageImage={mCollage}
      sidebarItems={sidebar}
      features={features}
    />
  );
}
